export const navLinks = [
    {
        label: 'Our Team',
        link: '/about',
    },
    {
        label: 'Gallery',
        link: '/success-stories',
    },
    {
        label: 'Office Tour',
        link: '/office-tour',
    },
    {
        label: 'Patient Forms',
        link: '/patient-forms',
    },
    {
        label: 'CareCredit',
        link: '/care-credit',
    },
    {
        label: 'Sunbit',
        link: '/sunbit',
    },
    {
        label: 'Radio',
        link: '/radio-stations',
    },
    {
        label: 'Appointment',
        link: '/contact',
    },
];
